module.exports = __webpack_public_path__ + "img/icon_monitoring.517bb266.png";